(function($) {
	$(".page-template-team-hub #filter-select").trigger("change");
})(jQuery);
